import React from 'react';
import { withTranslation } from 'react-i18next';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import ExcerptRenderer from '../../../../TextRenderer/ExcerptRenderer';
import shopThumbStyles from '../ShopThumb.scss';
var Content = function (_a) {
    var width = _a.width, height = _a.height, disabled = _a.disabled, deviation = _a.deviation, textContent = _a.textContent, disabledLabel = _a.disabledLabel, t = _a.t;
    return (React.createElement(DeviationLink, { deviation: deviation, className: shopThumbStyles['thumb'] },
        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height }),
        React.createElement("div", { className: shopThumbStyles['thumb-overlay'] }),
        React.createElement("div", { className: shopThumbStyles['thumb-overlay-top'] }),
        disabled && disabledLabel && (React.createElement("div", { className: shopThumbStyles['thumb-disabled-overlay'] },
            React.createElement("div", null, t(disabledLabel)))),
        React.createElement("div", { className: shopThumbStyles['description'] },
            React.createElement(ExcerptRenderer, { textContent: textContent }))));
};
export default withTranslation()(Content);
//# sourceMappingURL=Content.js.map